export default __webpack_public_path__ + "static/GT-America-Standard-Medium-46c07a9c4d508469cc7f06087a59dc35.ttf";